import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import {AgentRouteScoreModel} from "../../../../agents/angular/models/agent-route-score.model";
import {TaskModel} from "../../../../tasks/models/task.model";
import {TaskType} from "../../../../tasks/types/task.type";
import {AgentReference} from "../../../../agents/angular/models/agentReference.model";
import {TagType} from "../../../../tags/angular/types/tag.type";

require('./dashboard-agents-route-score-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-dashboard-agents-route-score-table-row',
  templateUrl: './dashboard-agents-route-score-table-row.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardAgentsRouteScoreTableRowComponent implements OnInit, OnChanges {

  @Input() agentRouteScore: AgentRouteScoreModel;
  @Output() viewTasksEvent = new EventEmitter<{
    agent: any,
    tasks: TaskModel[],
    plannedTasksOrder: string[],
    actualTasksOrder: string[]
  }>();
  @Output() viewAgentRoutesPerformanceEvent = new EventEmitter<{ agentRef: AgentReference }>;

  public tasksSequenceData: {
    details?: any;
    isCancelled?: boolean;
    isOutOfOrder?: boolean;
    number?: number;
  } [];
  public taskTypes: typeof TaskType = TaskType;
  public geoEnterTime: any;
  public geoExitTime: any;
  public tagTypes: typeof TagType = TagType;

  constructor() {
  }

  ngOnInit() {
    this.initData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.agentRouteScore && !changes.agentRouteScore.isFirstChange()) {
      this.initData();
    }
  }

  onViewRouteTasks() {

    this.viewTasksEvent.emit({
      agent: {
        ...this.agentRouteScore.agentReference,
        user: {...this.agentRouteScore.agentReference}
      }, tasks: this.agentRouteScore.routeTasks,
      plannedTasksOrder: this.agentRouteScore.plannedTasksOrder,
      actualTasksOrder: this.agentRouteScore.actualTasksOrder
    });
  }

  getBundleIndicationWidth(tasksCount) {
    return 10 + ((tasksCount.toString().length || 0) * 5);
  }


  private initData() {
    this.tasksSequenceData = [];

    this.agentRouteScore.actualTasksOrder.forEach((taskId, actualTaskIndex) => {
      const taskData: {
        details?: any;
        isCancelled?: boolean;
        isOutOfOrder?: boolean;
        number?: number;
      } = {}
      taskData.details = this.agentRouteScore.routeTasks.find(t => t.id === taskId);
      taskData.isCancelled = this.agentRouteScore.canceledTasks.includes(taskId);

      const plannedTaskIndex = this.agentRouteScore.plannedTasksOrder.findIndex((id) => id === taskId);
      taskData.isOutOfOrder = plannedTaskIndex !== actualTaskIndex;

      taskData.number = plannedTaskIndex + 1;

      this.tasksSequenceData.push(taskData);
    })


    if (!!this.agentRouteScore.actualTasksOrder?.length) {
      this.geoEnterTime = this.agentRouteScore.routeTasksExtraData?.find(item => item.taskId === this.agentRouteScore.actualTasksOrder[0])?.geofenceEventDataSegment?.startEntry;
      this.geoExitTime = this.agentRouteScore.routeTasksExtraData?.find(item => item.taskId === this.agentRouteScore.actualTasksOrder[this.agentRouteScore.actualTasksOrder.length - 1])?.geofenceEventDataSegment?.endEntry;
    }

  }

}
